import $ from "jquery";
import jQuery from "jquery";
import Cookies from 'js-cookie';
import '../util/textarea_resizer';

//HTML5 video autoplay on mobile fix

function mobileHeaderVideo() {
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('video#wp-custom-header-video').attr('playsinline', '');
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('video#wp-custom-header-video').attr('muted', '');
}


	// Link animate to area on same page
		$('a[href*=\\#content]').on('click', function(e){
			e.preventDefault();
			$('html, body').animate({
					scrollTop : $(this.hash).offset().top
			}, 1000);
		});

	// click the to-top arrow
	$('.to-top').on('click', function(e) {
		e.preventDefault();
		$('html, body').animate({ scrollTop: 0 }, 1000);
	})

export default {
	finalize() {
		//Get correct height for screen
		function vh() {
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		}
		vh();
		window.addEventListener('resize', () => {
			vh();
		});

		//Mobile menu
		$('button.toggle-menu').click(function() {
			console.log('menu');
			$('.mobile-menu').toggleClass('active');
		})

		//

		//Cookies
		function checkCookies() {
			let height = $('.cookie .box').height();
			height = height*2;
			if(!Cookies.get('terms')) {
				setTimeout( function() {
					$('.cookie .box').addClass('slide-in');
					$('footer').css('margin-bottom', height);
				}, 1000 );
				$(window).on('scroll', function() {
						$('.cookie .box').addClass('slide-in');
						$('footer').css('margin-bottom', height);
					});
				$('.cookie .approve').click( function() {
					Cookies.set('terms', 'approved');
					$('.cookie .box').removeClass('slide-in');
					$('footer').css('margin-bottom', '0');
					setTimeout(function() {$('.cookie').addClass('hidden')}, 1000);
				});
				$('.cookie .close').click( function() {
					$('.cookie .box').removeClass('slide-in');
					$('footer').css('margin-bottom', '0');
					setTimeout(function() {$('.cookie').addClass('hidden')}, 1000);
				});
			} else {
				$('.cookie').addClass('hidden');
				$('footer').css('margin-bottom', '0');
			}
		};

		setTimeout(checkCookies(), 1000);
		

		//Textarea
		$('textarea').autogrow();

		//On resize
		$(window).on('resize', function(){
			if( $(window).width() < 1024 ) {
				mobileHeaderVideo();
			}
		});
	}
}